import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import ReactCollapsible from 'react-collapsible';

import {
  collapsible,
  openCollapsible,
  trigger,
  openTrigger,
} from './scss/Collapsible.module.scss';
import { EASING } from './Collapsible.constants';

const Collapsible = ({ label, content }) => (
  <ReactCollapsible
    trigger={label}
    className={collapsible}
    openedClassName={classNames(collapsible, openCollapsible)}
    triggerClassName={trigger}
    triggerOpenedClassName={classNames(trigger, openTrigger)}
    transitionTime={300}
    easing={EASING}
  >
    <br />
    {content}
  </ReactCollapsible>
);

Collapsible.propTypes = {
  label: PropTypes.node.isRequired,
  content: PropTypes.node.isRequired,
};

export default Collapsible;
